/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-pause-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.5 3.75H6.25C5.56 3.75 5 4.31 5 5v10c0 .69.56 1.25 1.25 1.25H7.5c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zm6.25 0H12.5c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h1.25c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25z"/>'
  }
})
